import React, {Component} from 'react';
import { putToast, signin, authenticate, signout, isClientAuthenticated, stopTimer} from "../api";
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button} from 'reactstrap';
import Breadcrumb from "../common/breadcrumb";
import {Link} from 'react-router-dom';
import queryString from "query-string";


class Login extends Component {

    constructor (props) {
        super(props);
        const value=queryString.parse(this.props.location.search);

        this.state = {
            activeShow: true,
            startDate: new Date(),
            loading: true,
            em: value.em,
            mode: value.mode
        }
    }

    onValidSubmit = (event, values) => {
        signin(values).then(data => {
            if (data.error) {
                console.log(data.error);
                putToast.error(data.error)
            } else {
                authenticate(data, () => {
                    // users are requesting not to be taken to the dashboard
                    if(this.state.mode) {
                        this.props.history.push(`/pages/tournaments?mode=${this.state.mode}`);
                    } else this.props.history.push(`${process.env.PUBLIC_URL}`);

                    this.props.onHeaderDataChanged();
                });
            }
        });    
    };
    
    onInvalidSubmit = (event, errors, values) => {
        //this.setState({errors, values});
    };

    forgot = () => {
        var text = document.getElementById("email").value;
        this.props.history.push(`/pages/forgot-password?&em=${text}`)
    }
    
    componentDidMount() {
        this.setState({loading: true});
        if (isClientAuthenticated()) {
            signout().then(data => {
                if (data.error) {
                    console.log(data.error);
                } else {
                    this.props.onHeaderDataChanged();
                    this.setState({loading: false});
                }
            });        
        } else {
            this.setState({loading: false});
        } 
    }

    render () {
        if (this.state.loading) { return null; }
        stopTimer();      
        const {mode} = this.state;

        return (
            <div>
                <Breadcrumb title={'Login'}/>
                
                {/*Login section*/}
                <section className="login-page section-b-space">
                    <div className="container">

                    {mode === 'compete' && <h3 style={{marginTop: "25px", marginBottom: "50px"}}>Before you can register to compete in a tournament, you must either login or create an account.</h3>}
                    {mode === 'watch' && <h3 style={{marginTop: "25px", marginBottom: "50px"}}>Before you can register to observe a tournament, you must either login or create an account.</h3>}
                    {mode === 'judge' && <h3 style={{marginTop: "25px", marginBottom: "50px"}}>Before you can register to judge a tournament, you must either login or create an account.</h3>}

                        <div className="row">
                            <div className="col-lg-6">
                                <h4>Login</h4>
                                <div className="theme-card">
                                    <AvForm id="loginForm" className="theme-form" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} >
                                        <p>Please note: email address should be all lowercase.  Both email address and password are case sensitive.</p>
                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                            <AvField required="" id="email" name="email" type="email" defaultValue={this.state.em} className="form-control" placeholder="Email" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="review">Password</label>
                                            <AvField required="" name="password" type="password" className="form-control" id="review"
                                                   placeholder="Enter your password" />
                                        </div>
                                        <Button type="submit" className="btn btn-solid">Login</Button>
                                       &nbsp;
                                       <Button className="btn btn-solid" onClick={this.forgot} >Forgot?</Button>


                                    </AvForm>
                                </div>
                            </div>
                            <div className="col-lg-6 right-login">
                                <h4>New Account</h4>
                                <div className="theme-card ">
                                    <h4 className="title-font">Create an Account</h4>
                                    <p>To be part of a tournament, (as a competitor, judge, or guest) please login if you have an account, or register for a free account now. Registration is quick and easy and 
                                        it enables you to order from our shop, participate in online tournaments, and manage your notifications.                                        
                                    </p>                                    
                                    <p><strong style={{color: "red"}}>Note for parents trying to register their students:</strong> Each competitor and judge <em>must create their own account</em> and fill out there own profile.  If you are registering your student, <span style={{textDecoration: "underline"}}>please log out of your account and create an account in your student's name</span> in order to register them. The logout button is at the top right of the menu. Once they fill out their profile as a competitor, they will see the [Register for Events] Card which will allow them to register and pay.</p>
                                    <Link className="btn btn-solid" to={`${process.env.PUBLIC_URL}/pages/register`} >Create an Account</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default Login